













































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import countryData from '@/utils/country';

@Component({})
export default class CountrySelector extends Vue {
  @Prop() country!: any;
  @Prop() setCountry!: Function;
  @Prop({ default: false }) disabled?: boolean;
  public _close: any;
  public isOnTop: boolean = false;
  public openSelector: boolean = false;
  public keyword: string = '';
  public filterCountry: Array<any> = countryData;

  beforeMount() {
    this._close = e => {
      if (this.$el.contains(e.target)) {
        return;
      }
      this.openSelector = false;
      document.body.removeEventListener('click', this._close);
    };
  }
  beforeDestroy() {
    document.body.removeEventListener('click', this._close);
  }

  clickCountryCodeSelector() {
    if (this.openSelector || this.disabled) {
      return;
    }
    const size = 310;
    const screenHeight = window.innerHeight;
    const distanceWithTop = (this.$refs as any).selector.getBoundingClientRect().top;
    const distanceWithBottom = (this.$refs as any).selector.getBoundingClientRect().bottom;
    this.isOnTop = (screenHeight - distanceWithBottom) < size && (distanceWithTop >= size);
    setTimeout(() => {
      this.keyword = '';
      this.openSelector = true;
      document.body.addEventListener('click', this._close);
    });
  }

  handleChangeCountry(item) {
    this.openSelector = false;
    this.setCountry(item);
  }

  @Watch('keyword')
  watchKeyword() {
    this.filterCountry = countryData.filter(item =>
      `${item.name} (${item.code})`.toLowerCase().includes(this.keyword.toLowerCase())
    );
  }
}
